import MonthlyMatchingBanner from './MonthlyMatchingBanner'

export default MonthlyMatchingBanner
